<template>
  <ul class="social social-default position-relative">
    <li v-for="(social, i) in socialList" :key="i">
      <a :href="social.link" target="_blank" rel="noreferrer"
        ><img class="svg" :src="social.src" alt="social"
      /></a>
    </li>
  </ul>
  <!-- End. social -->
</template>

<script>
export default {
  data() {
    return {
      socialList: [
        {
          link: "https://www.facebook.com/yudha.tho/",
          src: require("../assets/img/svg/social/facebook.svg"),
        },
        {
          link: "https://www.instagram.com/yudhadie/",
          src: require("../assets/img/svg/social/instagram.svg"),
        },
        {
          link: "https://wa.me/6287860216576",
          src: require("../assets/img/svg/social/whatsapp.svg"),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
